module.exports = __webpack_public_path__ + "img/charity_2.8da63d10.png";